import StarterKit from '@tiptap/starter-kit'
import Color from '@tiptap/extension-color'
import { Link } from "@tiptap/extension-link"
import { Underline } from "@tiptap/extension-underline"
import { BackgroundColor } from '../extensions/backgroundColor'
import TextStyle from '@tiptap/extension-text-style'
import CharacterCount from '@tiptap/extension-character-count'
import {config} from "./corrector"
import FontFamily from '@tiptap/extension-font-family'
import TextAlign from '@tiptap/extension-text-align'

const extensions = [
    StarterKit.configure({
        heading: {
            levels: [1, 2, 3]
        }
    }),
    Link.configure({
        openOnClick: false,
        linkOnPaste: true,
    }),
    TextStyle,
    Color,
    BackgroundColor,
    Underline,
    CharacterCount.configure({
        limit: config.characterLimit,
    }),
    FontFamily.configure({
        types: ['textStyle'],
    }),
    TextAlign.configure({
        types: ['heading', 'paragraph'],
    })
];

export default extensions;